import { c as _c } from "react/compiler-runtime";
import { Footer } from '@/sections/layout/Footer';
import { PropsWithChildren } from 'react';
import { LINKS } from '@/constants/links';
import { GcssHeader } from '@/sections/layout/Header';
import { useRouter } from 'next/router';
import { Search } from '@/sections/gcss/Search';
import { SearchFormValuesGCSS } from '@/sections/gcss/hooks/useGcssSearch';
import { SeoHeader } from '../SeoHeader';
import { FormApi } from 'final-form';
import { Discover } from '@/sections/gcss/Discover';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { mergeClasses } from '@/utils/style';
import { Section } from '@/sections/layout/Header/useGcssSections';
type SearchForm = FormApi<SearchFormValuesGCSS, Partial<SearchFormValuesGCSS>>;
interface Props {
  headerSections: Section[];
  formValues: Partial<SearchFormValuesGCSS>;
  searchForm: SearchForm;
  isHomepage?: boolean;
  handleResetFilter?: () => void;
}
export function GcssLayout(props) {
  const $ = _c(19);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SeoHeader title="" nofollow={true} noindex={true} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.handleResetFilter || $[2] !== router.pathname) {
    t1 = router.pathname !== LINKS().gcssHomepage && <Search onSubmit={props.handleResetFilter} className="3xl:[&_input]:h-12 w-full xl:[&_input]:h-10" />;
    $[1] = props.handleResetFilter;
    $[2] = router.pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.headerSections || $[5] !== t1) {
    t2 = <nav><GcssHeader headerSections={props.headerSections} search={t1} /></nav>;
    $[4] = props.headerSections;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = props.isHomepage !== true && "mb-12 lg:mb-24";
  let t4;
  if ($[7] !== t3) {
    t4 = mergeClasses(t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props.children || $[10] !== t4) {
    t5 = <main className={t4}>{props.children}</main>;
    $[9] = props.children;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== props.isHomepage) {
    t6 = props.isHomepage !== true && <><SectionDelimiter color="bg-blue-50" background="bg-white" /><Discover /></>;
    $[12] = props.isHomepage;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Footer />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t5 || $[17] !== t6) {
    t8 = <div>{t0}{t2}{t5}{t6}{t7}</div>;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}